import {
    confirmRequestFailure,
    confirmRequestStart,
    confirmRequestSuccess,
    createRequestFailure,
    createRequestStart,
    createRequestSuccess,
    getAllRequestFailure,
    getAllRequestInvoiceSuccess,
    getAllRequestStart,
    getAllRequestSuccess,
    requestInvoiceSelectedFailure,
    requestInvoiceSelectedStart,
    requestInvoiceSelectedSuccess
} from '../reducers/request';
import axios from '../../api/axios';


// ?requestStatus=pending&requestFrom=courses&requestType=add
export const getAllRequest = (url) => async (dispatch) => {
    try {
        dispatch(getAllRequestStart());
        const response = await axios.get(url || `/request/getAllRequestsStudents/?requestFrom=courses`);
        if (response.status === 200) {
            dispatch(getAllRequestSuccess(response.data));
        }
    } catch (error) {
        dispatch(getAllRequestFailure());
    }
};

export const getAllRequestInvoice = (url) => async (dispatch) => {
    try {
        dispatch(getAllRequestStart());
        const response = await axios.get(url || `/request/getAllRequestsInvoice/?requestFrom=invoice`);
        if (response.status === 200) {
            dispatch(getAllRequestInvoiceSuccess(response.data));
        }
    } catch (error) {
        dispatch(getAllRequestFailure());
    }
};

export const requestDeleteStudentApproved = (
    requestId,
    approvedBy
) => async (dispatch) => {
    try {
        dispatch(confirmRequestStart());
        const response = await axios.put(`/request/deleteStudentRequestApproved/${requestId}`, { approvedBy });
        if (response.status === 200) {
            dispatch(confirmRequestSuccess());
            return {
                status: response.status,
                message: response.data.message
            };
        }
    } catch (error) {
        dispatch(confirmRequestFailure());
    }
};

export const requestAddStudentApproved = (
    requestId,
    approvedBy
) => async (dispatch) => {
    try {
        dispatch(confirmRequestStart());
        const response = await axios.put(`/request/addStudentApproved/${requestId}`, {
            approvedBy
        });
        if (response.status === 200) {
            dispatch(confirmRequestSuccess());
            return {
                status: response.status,
                message: response.data.message
            };
        }
    } catch (error) {
        dispatch(confirmRequestFailure());
    }
};

export const requestInvoiceApproved = (
    requestId,
    approvedBy
) => async (dispatch) => {
    try {
        dispatch(confirmRequestStart());
        const response = await axios.put(`/request/invoiceRequestApproved/${requestId}`, {
            approvedBy
        });
        if (response.status === 200) {
            dispatch(confirmRequestSuccess());
            return {
                status: response.status,
                message: response.data.message
            };
        }
    } catch (error) {
        dispatch(confirmRequestFailure());
    }
};

export const requestCreate = (
    student,
    requestBy,
    requestType,
    courses
) => async (dispatch) => {
    try {
        dispatch(createRequestStart());
        const response = await axios.post(`/request/createRequestStudent/`, {
            student,
            requestBy,
            requestType,
            courses
        });
        if (response.status === 201) {
            dispatch(createRequestSuccess());
            return {
                status: response.status,
                message: response.data.message
            };
        }
    } catch (error) {
        dispatch(createRequestFailure());
    }
};

export const requestCreateInvoice = (
    requestBy,
    payment,
) => async (dispatch) => {
    try {
        dispatch(createRequestStart());
        const response = await axios.post(`/request/createRequestInvoice/`, {
            requestBy,
            payment
        });
        if (response.status === 201) {
            dispatch(createRequestSuccess());
            return {
                status: response.status,
                message: response.data.message
            };
        }
    } catch (error) {
        dispatch(createRequestFailure());
    }
};

export const getRequestInvoiceDetails = (requestId) => async (dispatch) => {
    try {
        dispatch(requestInvoiceSelectedStart());
        const response = await axios.get(`/request/getRequestInvoiceDetails/${requestId}`);
        if (response.status === 200) {
            dispatch(requestInvoiceSelectedSuccess(response.data));
        }
    } catch (error) {
        dispatch(requestInvoiceSelectedFailure());
    }
};

